import styles from './styles.module.css';

const VideoVerticalContainer = (props) => {
    const { title, link, title1, link1, title2, link2, title3, link3, titleVideo, linkNotaVideo, urlVideo = '' } = props;
    let urlIframe;
    if (urlVideo.indexOf('youtube') != -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|(?:v|s(?:horts)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(urlVideo)
        urlIframe = `https://www.youtube.com/embed/${idVideo[1]}?autoplay=1&mute=1`;
    }
    if (urlVideo.indexOf('youtu') != -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|(?:v|s(?:horts)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(urlVideo)
        urlIframe = `https://www.youtube.com/embed/${idVideo[1]}?&autoplay=1&mute=1`;
    }

    return (

        <div className={`${styles["videoverticalcontainer-p"]}`}>
            {title &&  <div className={`${styles["contenedor-gral-tittulo-container"]}`}>
                <div className={`${styles["contenedor-left-titulo"]}`}>
                    <h2><a href={link}>{title}</a></h2>
                </div>
            
            <div className={`${styles["scroll-margin"]}`}>
                <nav className={`${styles["menu-el-scroll"]}`}>
                <ul>
                    {link1 && title1  &&  <li><a href={link1} >{title1}</a></li>}
                    {link2 && title2  &&  <li><a href={link2} >{title2}</a></li>}
                    {link3 && title3  &&  <li><a href={link3} >{title3}</a></li>}                
                </ul>
                </nav>
            </div>
            </div> 
            }



            <div className={`${styles["videoverticalcontainer-parent"]}`}>
                <div className={`${styles['primer-bloque']}`}>
                    <div className={` ${styles["grid-item2"]}`}>{props.renderContainerWidgetCallback(1, "DestacadaInContainers")}</div>
                </div>
                <div className={`${styles['segundo-bloque']}`}>
                    <div className={`${styles["grid-item-video"]}`}>
                        <iframe
                            src={urlIframe}
                            title={titleVideo}
                            frameBorder="0"
                            loading="lazy"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                        <h2 className={`${styles["title-video"]}`}><a href={linkNotaVideo}>{titleVideo}</a></h2>

                    </div>
                </div>
                <div className={`${styles['tercer-bloque']}`}>
                    <div className={` ${styles["grid-item"]}`}>{props.renderContainerWidgetCallback(2, "NotaContainerGrilla")}</div>
                    <div className={` ${styles["grid-item2"]}`}>{props.renderContainerWidgetCallback(3, "NotaContainerGrilla")}</div>
                </div>

            </div>
        </div>

    )
}
export default VideoVerticalContainer;
